import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateFulfillmentGroupPickedQuantities = {
  name: "updateFulfillmentGroupPickedQuantities" as const,
  input: z.object({
    fulfillmentGroupId: zExt.objectId(),
    fulfillmentOrderLineItemExternalId: z.string(),
    quantityPicked: z.number().int().min(0),
  }),
  output: z.object({
    success: z.boolean(),
    message: z.string().nullish(),
    pickSessionItemStatuses: z
      .array(
        z.object({
          fulfillmentOrderLineItemExternalId: z.string(),
          quantityPicked: z.number(),
        }),
      )
      .nullish(),
  }),
};
